let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hKY0Y")).then(() => parcelRequire('kGNbu'));